import React from 'react';
import PropTypes from 'prop-types';
import MobileSidebar from 'react-sidebar';
import Sidebar from '../../../App/SidebarComponent';
import NotFound from '../../../App/404';
import withAuth from '../../../App/Authenticate';
import documentStyles from '../../Document.scss';
import styleVariables from '../../../variables';
import Header from './Header';
import { Loader } from '../../../Elements';
import { Container, Divider, Grid, Rail, Segment } from 'semantic-ui-react';
import Brand from './Brand';
import Logo from './Logo';
import LineItems from './LineItems';
import SignatureBlocks from './SignatureBlocks';
import Terms from './Terms';
import Actions from './Actions';
import Library from './Library';

const ContractTemplateComponent = class ContractTemplateComponent extends React.Component {
  static propTypes = {
    node: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired,
    relay: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
    viewer: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.canEdit = this.canEdit.bind(this);
    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this);
    this.toggleSidebar = this.toggleSidebar.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

    this.state = {
      error: !this.props.node,
      sidebarOpen: false
    };
  }

  componentWillMount() {
    this.updateWindowDimensions();
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  onSetSidebarOpen(open) {
    this.setState({ sidebarOpen: open });
  }

  canEdit() {
    return this.props.params.action === 'edit';
  }

  toggleSidebar(ev) {
    ev.preventDefault();
    this.onSetSidebarOpen(!this.state.sidebarOpen);
  }

  updateWindowDimensions() {
    this.setState({
      window: { width: window.innerWidth, height: window.innerHeight }
    });
  }

  render() {
    const isLargeScreen = this.state.window.width >= 1280;

    const ActionsMenu = (
      <Actions
        node={this.props.node}
        params={this.props.params}
        relay={this.props.relay}
        router={this.props.router}
        windowDimensions={this.state.window}
        viewer={this.props.viewer}
      />
    );

    return (
      <div>
        {this.props.node &&
          <MobileSidebar
            sidebar={
              <Sidebar
                setSidebarOpenState={this.onSetSidebarOpen}
                router={this.props.router}
                viewer={this.props.viewer}
              />
            }
            sidebarClassName={documentStyles.sidebar}
            open={this.state.sidebarOpen}
            onSetOpen={this.onSetSidebarOpen}
            touch={false}
          >
            <Header
              toggleSidebar={this.toggleSidebar}
              sidebarOpen={this.state.sidebarOpen}
              document={this.props.node}
              relay={this.props.relay}
              windowDimensions={this.state.window}
              router={this.props.router}
              params={this.props.params}
              viewer={this.props.viewer}
            />
            <Container className={[documentStyles.container].join(' ')}>
              {!isLargeScreen &&
                this.state.window.width >= styleVariables.tabletBreakpoint &&
                <Grid>
                  <Grid.Row columns='equal'>
                    <Grid.Column>
                      {ActionsMenu}
                    </Grid.Column>
                  </Grid.Row>
                </Grid>}
              <Segment>
                {isLargeScreen &&
                  <Rail
                    position='right'
                    close
                    className={documentStyles.actionsMenuDesktop}
                  >
                    {ActionsMenu}
                  </Rail>}
                <Grid padded relaxed stackable>
                  <Grid.Row columns='equal'>
                    <Grid.Column>
                      <Logo
                        canEdit={this.canEdit()}
                        viewer={this.props.viewer}
                        node={this.props.node}
                        relay={this.props.relay}
                      />
                      <Brand
                        canEdit={this.canEdit()}
                        viewer={this.props.viewer}
                        node={this.props.node}
                        relay={this.props.relay}
                      />
                    </Grid.Column>
                    <Grid.Column />
                  </Grid.Row>
                  {(this.canEdit() ||
                    this.props.node.c_template_line_items.edges.length > 0) &&
                    <Grid.Row className={documentStyles.section}>
                      <Grid.Column width={16}>
                        <Divider horizontal className={documentStyles.heading}>
                          Line Items
                        </Divider>
                      </Grid.Column>
                    </Grid.Row>}
                  <Grid.Row columns='equal' className={documentStyles.section}>
                    <Grid.Column>
                      <LineItems
                        node={this.props.node}
                        relay={this.props.relay}
                        canEdit={this.canEdit()}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  {this.canEdit() &&
                    <Grid.Row columns='equal'>
                      <Grid.Column>
                        <Library
                          node={this.props.node}
                          relay={this.props.relay}
                          viewer={this.props.viewer}
                        />
                      </Grid.Column>
                    </Grid.Row>}
                  {(this.canEdit() || this.props.node.terms) &&
                    <Grid.Row className={documentStyles.section}>
                      <Grid.Column width={16}>
                        <Divider horizontal className={documentStyles.heading}>
                          Terms and Conditions
                        </Divider>
                      </Grid.Column>
                    </Grid.Row>}
                  {(this.canEdit() || this.props.node.terms) &&
                    <Grid.Row columns='equal' className={documentStyles.section}>
                      <Grid.Column>
                        <Terms
                          node={this.props.node}
                          relay={this.props.relay}
                          canEdit={this.canEdit()}
                        />
                      </Grid.Column>
                    </Grid.Row>}
                  {(this.canEdit() ||
                    this.props.node.c_template_signature_blocks.edges.length > 0) &&
                    <Grid.Row className={documentStyles.section}>
                      <Grid.Column width={16}>
                        <Divider horizontal className={documentStyles.heading}>
                          Signatures
                        </Divider>
                      </Grid.Column>
                    </Grid.Row>}
                  {(this.canEdit() ||
                    this.props.node.c_template_signature_blocks.edges.length > 0) &&
                    <Grid.Row columns='equal'>
                      <Grid.Column>
                        <SignatureBlocks
                          relay={this.props.relay}
                          node={this.props.node}
                          canEdit={this.canEdit()}
                        />
                      </Grid.Column>
                    </Grid.Row>}
                </Grid>
              </Segment>
            </Container>
          </MobileSidebar>}
        {!this.props.node &&
          <div>
            {this.state.error &&
              <NotFound viewer={this.props.viewer} />}
            {!this.state.error && <Loader />}
          </div>}
      </div>
    );
  }
};

export default withAuth(ContractTemplateComponent);



// WEBPACK FOOTER //
// ./webpack/components/Document/Template/Contract/ContractTemplateComponent.js